<template>
  <div>
    <Header></Header>

    <v-layout class="justify-center">
      <v-flex class="xs10 md8 lg7">
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
          <!-- Form -->
          <v-layout
            class="justify-center"
            style="background-color: #fff;margin-top: 3px; padding: 3rem 0 25rem 0"
          >
            <v-flex class="xs10 md8 lg7">
              <v-layout>
                <v-flex class="flex-center font-weight-bold">
                  <span style="font-size: 22px">{{ $t("register") }}</span>
                </v-flex>
              </v-layout>

              <v-layout class="mt-6">
                <v-flex class="font-weight-bold">
                  <span>{{ $t("first-name") }}</span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-text-field
                    required
                    :rules="requireRules"
                    dense
                    solo
                    flat
                    background-color="#E5E5E5"
                    v-model="data_register.name_th"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex class="font-weight-bold">
                  <span>{{ $t("last-name") }}</span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-text-field
                    background-color="#E5E5E5"
                    required
                    :rules="requireRules"
                    dense
                    solo
                    flat
                    v-model="data_register.last_th"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex class="font-weight-bold">
                  <span>{{ $t("phone-number") }}</span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-text-field
                    background-color="#E5E5E5"
                    append-outer-icon=""
                    clear-icon=""
                    append-icon=""
                    required
                    :rules="phoneRules"
                    dense
                    solo
                    flat
                    v-model="data_register.mobile_number"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex class="font-weight-bold">
                  <span>{{ $t("email") }}</span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-text-field
                    background-color="#E5E5E5"
                    required
                    :rules="emailRules"
                    dense
                    solo
                    flat
                    v-model="data_register.email"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex class="font-weight-bold">
                  <span>{{ $t("password") }}</span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-text-field
                    background-color="#E5E5E5"
                    required
                    :rules="passwordRules"
                    validation="^required|min:6,length"
                    :type="showPassword ? 'password' : 'text'"
                    color="#fff"
                    dense
                    solo
                    flat
                    v-model="data_register.password"
                  ></v-text-field>
                </v-flex>
                <!-- <v-flex
                    shrink
                    class="mt-2"
                    style="cursor: pointer;"
                    @click="showPassword = !showPassword"
                  >
                    <v-icon>remove_red_eye</v-icon>
                  </v-flex> -->
              </v-layout>

              <v-layout>
                <v-flex class="font-weight-bold">
                  <span>{{ $t("confirm-password-again") }}</span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-text-field
                    background-color="#E5E5E5"
                    required
                    :rules="passwordRules"
                    :type="showPassword ? 'password' : 'text'"
                    color="#fff"
                    dense
                    solo
                    flat
                    v-model="data_register.password_confirm"
                  ></v-text-field>
                  <!--                                        <span style="font-size: 12px;color: red" v-if="check_password_confirm">{{switchLanguage === 'th' ? 'รหัสผ่านไม่ตรงกัน' : 'password not match'}}</span>-->
                  <!--                                        <span style="font-size: 12px;color: green" v-if="!check_password_confirm">{{switchLanguage === 'th' ? 'รหัสผ่านตรงกัน' : 'password matches'}}</span>-->
                </v-flex>
              </v-layout>

              <v-layout mt-8>
                <v-flex class="text-center">
                  <span>By creating account, I accept TCDCCONNECT.com's </span>
                  <span
                    style="color: #FD5246; cursor: pointer"
                    @click="onGetTerm"
                    >Terms Of Use.</span
                  >
                </v-flex>
              </v-layout>

              <v-layout mt-8>
                <v-flex class="text-center">
                  <!-- :dark="valid"
                    :disabled="!valid"  -->
                  <v-btn
                    v-if="valid"
                    width="150"
                    color="#FD5246"
                    dark
                    @click="register"
                  >
                    ยืนยัน
                  </v-btn>
                  <v-btn v-else depressed width="150" color="#C5C5C5" dark>
                    ยืนยัน
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>

    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>

    <Footer id="footer"></Footer>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Register",
  components: {
    Loading,
    Header,
    Footer,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    check_password_confirm: false,
    valid: true,
    lazy: false,
    showPassword: true,
    data_register: {
      name_th: "",
      last_th: "",
      mobile_number: "",
      email: "",
      password: "",
      password_confirm: "",
    },
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    requireRules: [(v) => !!v || "The Field is required"],
    passwordRules: [
      (v) => !!v || "The Field is required",
      (v) => v.length >= 6 || "Value must be at least 6",
    ],
    phoneRules: [
      (v) => !!v || "The Field is required",
      (v) => /^[0-9]*$/.test(v) || "Value must be Number only",
      (v) =>
        (v.length >= 9 && v.length <= 10) ||
        "Value must be between 9-10 character",
    ],
  }),
  computed: {
    ...mapState({
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
    }),
  },
  methods: {
    ...mapActions("Page", ["getDataPage", "setPathUrl"]),
    checkpassword() {
      if (this.data_register.password === this.data_register.password_confirm) {
        this.check_password_confirm = false;
      } else {
        this.check_password_confirm = true;
      }
    },
    register() {
      if (this.data_register.password !== this.data_register.password_confirm) {
        this.$swal({
          icon: "error",
          title:
            this.switchLanguage === "th"
              ? "รหัสผ่านไม่ตรงกัน"
              : "password not match",
          confirmButtonColor: "#FD5246",
          confirmButtonText: "ตกลง",
        });
        // alert(this.switchLanguage === 'th' ? 'รหัสผ่านไม่ตรงกัน' : 'password not match')
      }
      // Register
      else {
        this.isLoading = true;
        this.$store
          .dispatch("auth/register", this.data_register)
          .then((res) => {
            this.isLoading = false;
            this.$swal({
              icon: "success",
              text:
                this.switchLanguage === "th"
                  ? "สมัครสมาชิกเรียบร้อยแล้ว"
                  : "Register Successfully",
              confirmButtonColor: "#FD5246",
              confirmButtonText: "ตกลง",
            }).then((result) => {
              if (result.value) {
                this.isLoading = true;
                setTimeout(() => {
                  this.isLoading = false;
                  this.$router.push("/login");
                }, 1000);
              }
            });
          })
          .catch((err) => {
            this.isLoading = false;
            this.$swal({
              icon: "warning",
              title: err.response.data.message,
              text: "อีเมลนี้ถูกใช้งานแล้ว",
              confirmButtonColor: "#FD5246",
              confirmButtonText: "ตกลง",
            });
          });
      }
    },
    setData() {
      this.data_register.name_th = "ดำ";
      this.data_register.last_th = "ใจดี";
      this.data_register.mobile_number = "058745214";
      this.data_register.email = "dum@mail.com";
      this.data_register.password = "123";
      this.data_register.password_confirm = "123";
    },
    onGetTerm() {
      this.$store.dispatch("portfolio/clearActiveMenuCate", 0);
      this.isLoading = false;
      this.setPathUrl("term");
      this.getDataPage("term");
      if (this.$route.name !== "Pages") {
        let routeData = this.$router.resolve({
          name: "Pages",
          query: { page: "term" },
        });
        window.open(routeData.href, "_blank");
        // this.$router.push({path: 'pages', query: {page: 'term'}})
      }
    },
  },
};
</script>

<style scoped></style>
